import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot, doc, getDocs } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import Lodinging from "../../components_root/loading.jsx";
import Lodingingimg from "../../components_root/loadingimg.jsx";
import { MdArrowBackIos, MdClose, MdAddAPhoto, MdBook, MdAccountBalance, MdEdit, MdDownload } from "react-icons/md";
import { PiBooks } from "react-icons/pi";
import { Uploader_files } from "../../components_root/uploader_files.js";
import { Update_voucher } from "./Update_voucher.js";
import './voucher.css';
import e from "cors";
import { number } from "framer-motion";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Voucher_read() {
     const servicetablename = "accountingfinancedb";
    const [oucher, setoucher] = useState("");
    const [amount, setAmount] = useState();
    const [description, setdescription] = useState("");
    const { Toastshow } = Toast();
    const [isLoading_banner, setIsLoading_banner] = useState(false);
    const navigate = useNavigate();
    const [voucherid, setVoucherid] = useState("");
    const [IsLoading2, setIsLoading2] = useState(false);
    const [editable, setEditable] = useState(false);
    const [isedit, setIsedit] = useState(false);
    const [vouchersdata, setVouchersdata] = useState([]);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);
const [accountguid, setaccountguid] = useState();
    const [logoUrl, setLogoUrl] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    //
    const handleCreate = async () => {
        if (!oucher || !oucher.trim()) {
            Toastshow("Please enter oucher name.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter description.");
            return;
        }
        const data = {
            voucherid,
            voucher_type: "oucher",
            voucher: oucher,
            amount: isNaN(Number(amount)) ? 0 : Number(amount),
            description: description,
            // Add other necessary fields here
        };
        const result = await Update_voucher(data);
        if (result.success) {
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {
            setVoucherid(uid);
            setIsedit(true);
        } else {
            setIsedit(false);
        }
    }, [window.location.search]);



    const fetchvouchers = async () => {
        if (!voucherid) return; // avoid query before UID exists

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        // Correct path: companies/{company_uid}/vouchers
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            where("voucherid", "==", voucherid)
        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                const v = vouchers[0] || {};

                setVouchersdata(vouchers);
                setEditable(v.editable || false);
                setAmount(v.amount || 0);
                setOld_file_uid(v.logo_uid || "null");
                setLogoUrl(v.logo_url || logo_default);
                setoucher(v.voucher || "");
                setdescription(v.description || "");
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    //

    const fetchledger_accounts = async () => {
        if (!voucherid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        const managerQ = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
            where("voucherid", "==", voucherid)
        );

        const unsubscribe = onSnapshot(
            managerQ,
            async (managerSnap) => {
                if (managerSnap.empty) {
                    setLedger_accountsdata([]);
                    setIsLoading2(false);
                    return;
                }

                const managerList = managerSnap.docs.map((d) => ({
                    id: d.id,
                    ...d.data(),
                }));

                const manager = managerList[0];
                const accountguid = manager?.accountguid;

                if (!accountguid) {
                    setLedger_accountsdata([]);
                    setIsLoading2(false);
                    return;
                }

                // Fetch ledger account
                const accountsQuery = query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", accountguid)
                );

                const accountsSnap = await getDocs(accountsQuery);
                const ledgerList = accountsSnap.docs.map((d) => ({
                    id: d.id,
                    ...d.data(),
                }));

                // Merge both tables → KEEP ledger + manager fields together
                const finalData = ledgerList.map((ledger) => ({
                    ...ledger,
                    ledgertype: manager.ledgertype,
                    amount: manager.amount,


                }));

                setLedger_accountsdata(finalData);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching ledger data:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };


    useEffect(() => {

        fetchvouchers();
        fetchledger_accounts();
    }, [voucherid]); // IMPORTANT

    //change logo
    const [logo_file, setLogo_file] = useState(null);
    const logo_Upload = async () => {
        if (!logo_file) return;
        if (!old_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Uploader_files({
            file: logo_file,
            servicetablename,
            fileuid: voucherid,
            editable,
            tablename: "vouchers",
            filename: "logo",
            old_file_uid,
        });

        if (result.success) {
            Toastshow("Successfully!");
            setLogo_file(null);
            fetchvouchers();
        } else {

            setLogo_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (logo_file) {
            logo_Upload();
        }
    }, [logo_file]);
       useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const tab = params.get("accountguid");
     setaccountguid(tab);
        }, []);
 useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape") {
      navigate(-1);
    }
  };

  window.addEventListener("keydown", handleEsc);

  return () => {
    window.removeEventListener("keydown", handleEsc);
  };
}, [navigate]);
    return (
        <div >
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
onClick={() => navigate(-1)}
                            className="button-ui0 text-h2 bold p-2 cursor"
                        >
                            <MdArrowBackIos className="icon" />Voucher
                        </div></td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="post-container p-2 ">

                {accountguid}

            </div>

        </div>
    );
}
